<script>
import checkoutMixin from '@/v-shop/checkout/checkout-mixin'
export default {
	mixins: [checkoutMixin],
	data() {
		return { btnStatus: 'default', redirecting: false }
	},
	methods: {
		async submit() {
			if ((await this.checkout.beforeConfirm()) === false) return
			this.btnStatus = 'loading'
			let response = await this.checkout.stepSubmit()
			const orderId = response.data?.stepResponse?.orderId
			if (orderId) {
				window.location.href = this.$router.resolve({
					name: 'user.order-detail',
					params: { id: orderId },
				}).href
				this.redirecting = true
			} else {
				this.btnStatus = 'error'
			}
		},
	},
}
</script>
<template>
	<div>
		<div>
			<b> Confirma tu compra para avanzar. </b>
		</div>
		<div class="d-flex justify-center justify-sm-end pt-6">
			<IndeterminateProgressBtn
				v-model="btnStatus"
				default-color="cta"
				success-color="success"
				error-color="error"
				@click="submit()"
				:error-duration="5000"
				block
				x-large
			>
				Confirmar Compra con Pago en Efectivo
				<template #loading>
					{{ redirecting ? 'Ya casi terminamos...' : 'Generando tu Orden de Compra...' }}
				</template>
				<template #success>
					<div></div>
				</template>
				<template #error>
					<v-icon left> mdi-close-thick </v-icon>
					Lo sentimos, ha ocurrido un error
				</template>
			</IndeterminateProgressBtn>
		</div>
	</div>
</template>

<style></style>

